import { ObjectId } from 'bson';

export interface ImageModelData {
  _id: ObjectId;
  url: string;
}

export class ImageModel {
  constructor(public readonly data: ImageModelData) {}

  get _id(): ObjectId {
    return this.data._id;
  }

  get url(): string {
    return this.data.url;
  }

  canEdit() {
    return false;
  }

  get editLink(): string | null {
    return null;
  }

  async delete() {
    throw new Error('Image is not deletable');
  }

  async report() {
    throw new Error('Image is not reportable');
  }
}
